const listener = {
    active: false,
    listenerFn: null
}

export default listener;